import { render, staticRenderFns } from "./TricolorLine.vue?vue&type=template&id=23bd68ac&scoped=true&"
import script from "./TricolorLine.vue?vue&type=script&lang=js&"
export * from "./TricolorLine.vue?vue&type=script&lang=js&"
import style0 from "./TricolorLine.vue?vue&type=style&index=0&id=23bd68ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bd68ac",
  null
  
)

export default component.exports